import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.approval-forms', {
        url: '/forms',
        component: 'requestCenterApprovalForms',
        redirectTo: 'company.request-center.approval-forms.list',
        resolve: {policies, approvalForms},
    })
}

/** @ngInject */
function approvalForms(ApprovalFormsService, $stateParams) {
    return ApprovalFormsService.getApprovalFormsForCompany($stateParams.companyId);
}

/** @ngInject */
function policies(ApprovalPoliciesService, $stateParams) {
    return ApprovalPoliciesService.getPoliciesForCompany($stateParams.companyId);
}




// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/approval-forms.state.js